import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";

@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.css"],
})
export class ForgetPasswordComponent implements OnInit {
  screen_1: boolean = true;
  loginForm: FormGroup;
  signupForm: FormGroup;
  isOtpScreen: boolean = false;
  isLoading: boolean = false;
  screen_2: boolean = false;
  formSubmitted: boolean = false;
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _snackBar: MatSnackBar,
    private authServices: AuthService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
    });
  }

  change_Password() {
    this.signupForm = this.fb.group({
      newPassword: ["", [Validators.required, Validators.minLength(8)]],
      confirmPassword: ["", [Validators.required, Validators.minLength(8)]],
    });
  }

  backTo() {
    this.screen_1 = true;
    this.loginForm.reset();
    this.isOtpScreen = false;
    this.signupForm.reset();
  }

  otpToken: string;
  onOtpChange(event) {
    this.otpToken = event;
  }

  otpSent: boolean = false;
  showOtpComponent: boolean = true;
  userEmail: any;
  createOtp() {
    this.showOtpComponent = false;
    this.otpToken = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);

    if (this.loginForm.valid) {
      const email = this.loginForm.controls.email.value.toLowerCase();
      this.userEmail = email;
      let req = {
        email: this.loginForm.controls.email.value.toLowerCase(),
        type: "UFP",
      };

      console.log(req);
      this.isLoading = true;

      this.authServices.otpcreateApi(req).subscribe(
        (res) => {
          this.isLoading = false;
          if (res["message"] == "Success") {
            this._snackBar.open("OTP sent to your email!", "", {
              duration: 5000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
            this.screen_1 = false;
            this.isOtpScreen = true;
          } else {
          }
          this.isLoading = false;
          //this.getChildList();
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
  verifiedotpToken: any;
  verifyOtp() {
    let request = {
      email: this.loginForm.controls.email.value.toLowerCase(),
      type: "UFP",
      otp: parseInt(this.otpToken),
    };

    // console.log(request);
    this.isLoading = true;
    this.authServices.verifyOtpApi(request).subscribe(
      (res) => {
        this.isLoading = false;
        this.change_Password();
        if (res["message"] == "Success") {
          this.verifiedotpToken = res["data"]["token"];
          this.screen_1 = false;
          this.isOtpScreen = false;
          this.signupForm.reset();
          this.screen_2 = true;
          // console.log(this.otpToken);
          // this.getVendorProfile();
          this._snackBar.open("OTP verified!", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  passwordVisible: boolean = false;
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  visiblePassword: boolean = false;
  togglePasswordVisibility1() {
    this.visiblePassword = !this.visiblePassword;
  }
  ChangePassword() {
    this.formSubmitted = true;
    let req = {
      email: this.userEmail,

      newPassword: this.signupForm.controls["newPassword"].value,
      confirmPassword: this.signupForm.controls["newPassword"].value,
      otpToken: this.verifiedotpToken,
    };

    if (
      this.signupForm.controls["confirmPassword"].value !=
      this.signupForm.controls["newPassword"].value
    ) {
      this._snackBar.open("Confirm password should be same", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["failure"],
      });
      return;
    }

    if (this.signupForm.valid) {
      this.authServices.forgetPassword(req).subscribe(
        (res) => {
          //   debugger;
          if (
            res["message"] == "Success" ||
            res["body"]["message"] == "Success"
          ) {
            // this.createPassword();

            this._snackBar.open("Password changed successfully!!", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });

            this.router.navigate(["auth/login"]);
          } else {
          }
        },
        (err) => {
          console.log("There is something wrong");
        }
      );
    }
  }
}
